// extracted by mini-css-extract-plugin
export var $animation_name = "NoChristmasProductsList-module--$animation_name--9d33b";
export var ProductCard = "NoChristmasProductsList-module--ProductCard--2a034";
export var ProductsList = "NoChristmasProductsList-module--ProductsList--8a432";